let authData = null;

export const getAuthData = () => {
  try {
    const data = JSON.parse(window.sessionStorage.getItem('authData'));

    if (!data) return authData

    authData = data;
    return data;
  } catch { return authData; }
};

export const getVersion = () => {
  try {
    const { version } = JSON.parse(window.sessionStorage.getItem('version'));
    return version;
  } catch { return null; }
};
